import React, { useState } from 'react';

import { useMutation, useQuery } from '@betterment/js-runtime';
import { Box, BoxProps, IconButton } from '@betterment/samba-react';

import { DismissedAdvisorCard } from '../services/api/types/dismissed_advisor_cards';

interface Props {
  cardName: string;
}

export const DismissableCard: React.FC<React.PropsWithChildren<BoxProps & Props>> = ({
  cardName,
  children,
  ...cardProps
}) => {
  const { loading, data: dismissedCard } = useQuery<DismissedAdvisorCard>('/api/v1/dismissed_advisor_cards', {
    qs: { card: cardName },
  });
  const [postDismissedCard] = useMutation('/api/v1/dismissed_advisor_cards', {
    method: 'post',
  });
  const [isCardClosed, setIsCardClosed] = useState(false);

  const handleDismissedCard = async () => {
    setIsCardClosed(true);
    await postDismissedCard({ card: cardName });
  };

  if (loading || dismissedCard?.dismissed || isCardClosed) return null;

  return (
    <Box
      css={{
        display: 'flex',
        backgroundColor: 'background.surface',
        color: 'text',
        p: 'space.300',
        mb: 'space.300',
        boxShadow: 'xs',
        borderRadius: 'medium',
        position: 'relative',
      }}
      {...cardProps}
    >
      {children}
      <IconButton
        css={{
          top: '12',
          right: '12',
          position: 'absolute',
        }}
        label="Close"
        name="X"
        spacing="compact"
        onClick={() => {
          void handleDismissedCard();
        }}
      />
    </Box>
  );
};
